import React, { useState } from 'react';
import "./styles/TabsTypesNavigation.scss"
import Masks from "../VectorIcons/Masks";
import Microphone from "../VectorIcons/Microphone";

const contentTypeByTab = {
  "Dramaturgia Curta": 1,
  "Dramaturgia Longa": 1,
  "Variedades": 2,
};

const TabsTypesNavigation = (props) => {
  const { data, setFilter, formatGroups } = props

  const [stateCurrentType, setCurrentType] = useState("all")

  const icons = (type) => {
    let list = {
      "Dramaturgia Curta": (<Masks color={`${type === stateCurrentType ? "#fff" : "#adafef"}`}/>),
      "Dramaturgia Longa": (<Masks color={`${type === stateCurrentType ? "#fff" : "#adafef"}`}/>),
      "Variedades": (<Microphone color={`${type === stateCurrentType ? "#fff" : "#adafef"}`}/>)
    }

    return list[type];
  }

  const clearFilter = () => {
    setFilter({
      origins: [1, 2],
      limit: 12,
      channelIds: [],
      formatIds: [],
      contentType: undefined,
      title: "",
      pageNumber: 0,
    });

    setCurrentType("all");
  };

  const setCurrenTypeAndFilter = (type) => {
    setCurrentType(type);

    const formatIds = formatGroups[type] || [];
    const contentType = contentTypeByTab[type];

    setFilter({
      origins: [1, 2],
      limit: 12,
      channelIds: [],
      formatIds,
      contentType,
      title: "",
      pageNumber: 0,
    });
  };

  const ContentTypesFree = (props) => {
    const {contents} = props

    return (
      <div className="searchesNavigationContainer">
        <div className={`type ${
            stateCurrentType === "all" ? "active" : ""
          }`}
          onClick={() => clearFilter()}
        >
          <span className="typeLabel">Todos</span>
        </div>
        {!!contents &&
        contents.map((item) => {
          return (
            <div
              className={`type ${
                stateCurrentType === item.value ? "active" : ""
              }`}
              onClick={() => setCurrenTypeAndFilter(item.value)}
              key={item.id}
            >
              {icons(item.value)}
              <span className="typeLabel">{item.value}</span>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="searchNavigation">
      <ContentTypesFree contents={data}/>
    </div>
  );
};

export default TabsTypesNavigation;